import { TNewsState, TNewsActions } from '../../types/news';

export const newsActionTypes = {
  GET_NEWS_REQUEST: 'NEWS/GET_NEWS_REQEUST',
  GET_NEWS_SUCCESS: 'NEWS/GET_NEWS_SUCCESS',
  GET_DETAIL_REQUEST: 'NEWS/GET_DETAIL_REQUEST',
  GET_DETAIL_SUCCESS: 'NEWS/GET_DETAIL_SUCCESS',
} as const;

const initialState: TNewsState = {
  list: [],
  currentDetail: null,
  listMeta: {
    from: 1,
    to: 1,
    total: 1,
    current_page: 1,
    results_per_page: 1,
    last_page: 1,
    has_more_pages: false,
  },
};

export default (state: TNewsState = initialState, action: TNewsActions): TNewsState => {
  switch (action.type) {
    case newsActionTypes.GET_NEWS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };

    case newsActionTypes.GET_DETAIL_SUCCESS:
      return {
        ...state,
        currentDetail: action.payload,
      };
    default:
      return state;
  }
};

export const actions = {
  getNewsRequest: () => ({ type: newsActionTypes.GET_NEWS_REQUEST }),
  getNewsDetail: (payload: number) => ({ payload, type: newsActionTypes.GET_DETAIL_REQUEST }),
};
